<template>
  <div>
    <common-dialog ref="dialog" width="300px" center title="上传文件" :save-func="() => { }"
      :confirm-on-close-change="false" @close-saved="$emit('close-saved')">
      <template slot="form">
        <div style="text-align: center;margin-bottom: 30px;">
          <div style="margin-top: 15px;">
            <import-file :upload-url="api.fileImportUrl" text="上传文件" w="150px" @on-uploaded="uploaded" />
          </div>
          <div style="margin-top: 30px;" v-if="detailUrl">
            <el-button style="width: 150px;" type="danger" plain @click="detail">下载错误明细</el-button>
          </div>
        </div>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import importFile from "@/components/common/files/importFile";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    importFile,
  },
  data() {
    return {
      api: require("@/api/wx/order").default,
      attach: require("@/api/common/attach").default,
      detailUrl: "",
    };
  },
  computed: {},
  methods: {
    detail() {
      this.attach.downloadByUrl(this.detailUrl, "错误明细.xlsx");
    },
    uploaded(res) {
      if (res.code != 0) {
        if (res.code == 2) {
          this.detailUrl = res.data;
        } else {
          this.$message.error(res.msg);
        }
      } else {
        this.$emit("upload-success");
        this.detailUrl = "";
        this.close();
      }
    },
  },
};
</script>
<style lang="scss"></style>